export const ROUTER_OPTIONS = Symbol.for("ROUTER_OPTIONS");
